import { render, staticRenderFns } from "./ShowMailingContent.vue?vue&type=template&id=142a76b8&scoped=true"
import script from "./ShowMailingContent.vue?vue&type=script&lang=js"
export * from "./ShowMailingContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142a76b8",
  null
  
)

export default component.exports